import { FC } from 'react';

export const Loader:FC = () => <div className="flex justify-center items-center w-full h-full"><div className="lds-dual-ring" /></div>;
